import React from "react"
import * as styles from "./icon.module.css"

export default ({ id, tip, noDarkMode = false }) => (
  <i className={styles[id]} data-no-dark-mode={noDarkMode} data-tip={tip} />
)
